
import { Upload } from "lucide-react";

interface UploadActionsProps {
  filesCount: number;
  onUpload: () => void;
}

export function UploadActions({ filesCount, onUpload }: UploadActionsProps) {
  return (
    <button
      onClick={onUpload}
      className="w-full py-2 px-4 rounded-lg hover:opacity-90 transition-colors duration-300 flex items-center justify-center space-x-2"
      style={{
        backgroundColor: '#00F5D0',
        color: '#0A0D14',
      }}
    >
      <Upload className="h-5 w-5" />
      <span>Upload {filesCount} file{filesCount !== 1 ? "s" : ""}</span>
    </button>
  );
}
